import reducer, * as actions from './slice'
import * as selectors from './selectors'
import name from './name'

const exports = {
  reducer,
  actions,
  selectors,
  name
}

export default exports
